const localeRedirectMap = {
  'es-es': 'es',
  'es-mx': 'mx',
  'es-co': 'co',
}

export default function ({ route, redirect }) {
  const pathSegments = route.path.split('/')
  const localeSegment = pathSegments[1]

  if (localeRedirectMap[localeSegment]) {
    const newLocale = localeRedirectMap[localeSegment]
    pathSegments[1] = newLocale
    const newPath = pathSegments.join('/') || '/'

    return redirect(301, { path: newPath, query: route.query, hash: route.hash })
  }
}
